import { Link, Navigate, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import CategoryPage from './pages/Category';
import ProductPage from './pages/Product';
import CheckoutNew from './pages/CheckoutNew';
import Payment from './pages/Payment';
import OrderConfirmation from './pages/OrderConfirmation';
import Legal from './pages/Legal';
import AdminLogin from './pages/admin/Login';
import AdminShell, { RequireAdmin } from './pages/admin/AdminShell';
import AdminOrders from './pages/admin/Orders';
import AdminProducts from './pages/admin/Products';
import AdminCategories from './pages/admin/Categories';
import AdminSettings from './pages/admin/Settings';

function NotFound() {
  return (
    <div className="grid-paper">
      <div className="mx-auto max-w-2xl px-4 py-20 text-center">
        <p className="font-serif text-6xl text-board">404</p>
        <h1 className="mt-4 text-3xl">Stránka nenalezena</h1>
        <p className="mt-3 text-ink-soft">
          Zkuste to prosím z&nbsp;domovské stránky, možná odkaz už neplatí.
        </p>
        <Link
          to="/"
          className="mt-8 inline-flex h-12 items-center rounded-xl bg-board px-6 font-semibold text-chalk transition hover:bg-board-deep"
        >
          Zpět do katalogu
        </Link>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/o-nas" element={<About />} />
        <Route path="/kategorie/:slug" element={<CategoryPage />} />
        <Route path="/produkt/:slug" element={<ProductPage />} />
        <Route path="/pokladna/nova" element={<CheckoutNew />} />
        <Route path="/pokladna/:token" element={<Payment />} />
        <Route path="/objednavka/:token" element={<OrderConfirmation />} />
        <Route path="/obchodni-podminky" element={<Legal doc="obchodni-podminky" />} />
        <Route path="/odstoupeni-od-smlouvy" element={<Legal doc="odstoupeni-od-smlouvy" />} />
        <Route path="/ochrana-osobnich-udaju" element={<Legal doc="ochrana-osobnich-udaju" />} />
        <Route path="/reklamacni-rad" element={<Legal doc="reklamacni-rad" />} />
        <Route path="*" element={<NotFound />} />
      </Route>

      {/* Admin-lite (WP8), vlastní shell mimo obchodní layout. */}
      <Route path="/admin/prihlaseni" element={<AdminLogin />} />
      <Route
        path="/admin"
        element={
          <RequireAdmin>
            <AdminShell />
          </RequireAdmin>
        }
      >
        <Route index element={<Navigate to="objednavky" replace />} />
        <Route path="objednavky" element={<AdminOrders />} />
        <Route path="produkty" element={<AdminProducts />} />
        <Route path="kategorie" element={<AdminCategories />} />
        <Route path="nastaveni" element={<AdminSettings />} />
      </Route>
    </Routes>
  );
}
